import { createBrowserRouter } from 'react-router'

import Index from './pages/Index'
import Notfound from './pages/Notfound'
import Auth from './pages/Auth'
import LayoutV6 from "@/components/Layout/LayoutV6";
import LayoutBac from "@/components/Layout/LayoutBac";
import AuthLayout from "@/components/Layout/AuthLayout";
import PrivacyP from "./pages/Index/doc/PrivacyAgreement";
import PrivacyU from "./pages/Index/doc/UserAgreement";
import Charge from "./pages/Charge";
import UserDetail from "./pages/User";
import EvaluationPage from "./pages/Evaluation";
import AnalysisPage from "./pages/Analysis";
import DebugPage from "./pages/Debug";
import IframePage from "./pages/IframePage";
import RealTimeTranscription from "./pages/RealTimeTranscription";
import Login, { action as loginAction } from './pages/Auth/login';
import SignUp, { action as signUpAction } from './pages/Auth/sign-up';
import ForgotPassword, { action as forgotPasswordAction } from './pages/Auth/forgot-password';
import AuthConfirm, { loader as authConfirmLoader } from './pages/Auth/auth.confirm';
import AuthError from './pages/Auth/auth.error';
import UpdatePassword, { action as updatePasswordAction, loader as updatePasswordLoader } from './pages/Auth/update-password';
import ProtectedPage, { loader as protectedLoader } from './pages/Auth/protected';
import { loader as logoutLoader } from './pages/Auth/logout';

const router = createBrowserRouter([

  {
    // no path on this parent route, just the component
    Component: LayoutV6,
    children: [
      { index: true, Component: Index },
      { path: "nfd", Component: Notfound },
      {
        path: "agreement",
        children:[
          { path: "user", Component: PrivacyU },
          { path: "privacy", Component: PrivacyP },
        ]
      },
      {
        path: "charge",
        children:[
          { path: "default", Component: Charge },
        ]
      },
      {
        path: "user",
        children:[
          { path: "detail", Component: UserDetail },
        ]
      },
      {
        path: "evaluation",
        children:[
          { path: ":historyId", Component: EvaluationPage },
        ]
      },
      {
        path: "analysis",
        Component: AuthLayout,
        children: [
          { index: true, Component: AnalysisPage },
          { path: "iframe", Component: IframePage },
          { path: "realtime", Component: RealTimeTranscription },
          { path: "debug", Component: DebugPage },
        ],
      },
    ],
  },
  {
    path: 's_auth',
    children: [
      { index: true, Component: Auth },
      { path: "login", Component: Login, action: loginAction },
      { path: "sign-up", Component: SignUp, action: signUpAction },
      { path: "forgot-password", Component: ForgotPassword, action: forgotPasswordAction },
      { path: "confirm", Component: AuthConfirm, loader: authConfirmLoader },
      { path: "error", Component: AuthError },
      { path: "update-password", Component: UpdatePassword, loader: updatePasswordLoader, action: updatePasswordAction },
      { path: "logout", loader: logoutLoader },
    ],
  },
  {
    path: 'protected',
    Component: ProtectedPage,
    loader: protectedLoader,
  },

  {
    path: '*',
    element: (
      <LayoutV6>
        <Notfound />
      </LayoutV6>
    ),
  },
])

export default router
